import { useEffect, useRef } from "react";

/**
 * 共通のデバウンス＆キャンセル付き検索トリガー
 * @param {object} opts
 * @param {string|number|any[]} opts.value 依存する入力値
 * @param {function} opts.onSearch async可。返値がpromiseならキャンセル時に解放
 * @param {number} [opts.delay=400]
 */
export default function useDebouncedSearch({ value, onSearch, delay = 400 }) {
  const timerRef = useRef(null);
  const active = useRef(true);

  useEffect(() => {
    active.current = true;
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      const maybePromise = onSearch?.();
      if (maybePromise && typeof maybePromise.then === "function") {
        maybePromise.catch(() => {}); // エラーは呼び出し側で扱う
      }
    }, delay);

    return () => {
      active.current = false;
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [value, onSearch, delay]);
}
